module.exports = __webpack_public_path__ + "img/img25.17f438d8.png";